import { render } from "./Live.vue?vue&type=template&id=2bf3d06a&scoped=true"
import script from "./Live.vue?vue&type=script&lang=js"
export * from "./Live.vue?vue&type=script&lang=js"

import "./Live.vue?vue&type=style&index=0&id=2bf3d06a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bf3d06a"]])

export default __exports__